export const actionButtonStyles = theme => ({
  margin: theme.spacing(1, 'auto', 0),
});

export const cardBodyDividerStyles = theme => ({
  margin: `0 auto ${theme.spacing(1)}`,
  textAlign: 'center',
  width: '130px',
});

export const ellipsesStyles = theme => ({
  '&:hover': {
    backgroundColor: theme.palette.secondary.light,
  },
  backgroundColor: theme.palette.white,
  borderRadius: '100%',
  color: theme.palette.secondary.main,
  cursor: 'pointer',
  height: 24,
  marginRight: '-11px',
  marginTop: '-3px',
  minWidth: 24,
  paddingBottom: 0,
  width: 24,
});

export const ellipsesActiveStyles = theme => ({
  backgroundColor: theme.palette.secondary.medium,
});

export const expirationTextStyles = theme => props => ({
  color: props.isExpiredDate ? theme.palette.error.dark : theme.palette.text.primary,
});

export const headerStyles = theme => props => ({
  display: 'grid',
  gridTemplate: props.viewBy === 'carrier' ? '1fr / 5fr 1fr' : 'repeat(2, 1fr) / 5fr 1fr',
  marginBottom: props.viewBy === 'carrier' ? theme.spacing(2) : 0,
});

export const labelTextStyles = {
  fontSize: 18,
  fontWeight: 300,
  letterSpacing: '0.3px',
  lineHeight: '28px',
};

export const lastUsedTextStyles = theme => ({
  marginBottom: theme.spacing(2),
  marginTop: theme.spacing(1),
});
